import "./FlatCurvedPanels.module.css";
import Header from "@/reusable_sections/Header";
import Breadcrumbs from "./sections/Breadcrumbs";
import PanelHero from "./sections/PanelHero";
import ScreenTypes from "./sections/ScreenTypes";
import QuoteCta from "./sections/QuoteCta";
import CustomFabricationCta from "./sections/CustomFabricationCta";
import Footer from "@/reusable_sections/Footer";
export default function FlatCurvedPanelsPage() {
  return <div>
      <Header />
      <Breadcrumbs />
      <PanelHero />
      <ScreenTypes />
      <QuoteCta />
      <CustomFabricationCta />
      <Footer />
    </div>;
}